import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeading } from './HomePrimitives';
import { PlanPair } from '../payg/PaygSections';
import './growth-timeline.css';
import '../payg/payg.css';

export const HomePricing = () => (
  <section id="pricing" className="hm-band hm-pricing vx-pricing" data-testid="home-pricing-section"><div className="hm-container">
    <SectionHeading id="home-pricing" number="08" label="PRICING" title="True pay as you go." accent="Only pay for what you use." description="Full platform access, unlimited sub-accounts and $10 in free credit. AI voice agents from $0.11/min." dark />
    <PlanPair id="" />
    <div className="vx-pricing-foot">
      <Link to="/pricing" className="hm-text-link" data-testid="home-pricing-full-link">Estimate your cost<ArrowUpRight size={16} /></Link>
      <p className="vx-footnote" data-testid="home-pricing-terms">Usage billed from your balance in USD. Phone numbers and carrier minutes are billed by your phone provider.</p>
    </div>
  </div></section>
);
